import {ListItem as MUIListItem_, ListItemText as MUIListItemText} from '@material-ui/core'
import {
  List as GWCList,
  ListItem as GWCListItem,
  ListItemProps as GWCListItemProps,
  ListProps as GWCListProps,
} from '@yandex-taxi/go-web-components'

/** @deprecated */
export const List = GWCList
/** @deprecated */
export const ListItem = GWCListItem
/** @deprecated */
export const ListItemText = MUIListItemText
/** @deprecated */
export const MUIListItem = MUIListItem_
/** @deprecated */
export type ListItemProps = GWCListItemProps
/** @deprecated */
export type ListProps<T> = GWCListProps<T>
